module.exports = __webpack_public_path__ + "img/email-redaction-screen2.1338601e.png";